<template>
    <div>
        <button :disabled="disabled" v-if="!loading && !asMailInput" type="button" :class="triggerClass" data-bs-toggle="modal" data-bs-target="#userSearchModal">
            {{ triggerText }}
        </button>

        <div class="input-group flex" v-if="asMailInput">

            <input @blur="handleEmailBlur" :disabled="disabled" name="email" type="text" id="email" class="form-control right-border-none" v-if="!selectedUser.email" v-bind:placeholder="triggerText" v-model="query" v-on:keydown.enter.prevent='searchByInput'>
            <input type="email" id="email" class="form-control right-border-none" v-if="selectedUser.email" v-bind:placeholder="triggerText" v-model="selectedUser.email" disabled="disabled">
            <input type="hidden" name="email" v-if="selectedUser.email" v-model="selectedUser.email">

            <button :disabled="disabled" class="input-group-text transparent user-search-button" type="button" v-on:click.prevent="searchByInput">
                <span class="fa fa-search"></span>
            </button>
        </div>
        <p v-if="loading && asMailInput">loading...</p>

        <p v-if="loading && !asMailInput" :class="triggerClass">
            <span class="spinner anim-spin"></span>
        </p>
        <portal to="modal">
            <form @submit.prevent="search">
                <div class="modal fade" id="userSearchModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h2 class="user-search-title">Users</h2>
                                <div class="search-form_wrapper">
                                    <div class="search-form-mask open">
                                        <input type="text" class="search-input" v-model="query" :placeholder="'Search for users with email or name...'">
                                        <input class="search-input__button" />
                                        <button class="btn btn-light sb-icon-search">
                                            <span class="fa fa-search">
                                                <span class="visually-hidden">Search</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-body">
                                <div v-if="loading">Loading...</div>
                                <template v-else>
                                    <table v-if="pagination.data.length" class="table table-hover table-borderless">
                                        <thead>
                                            <tr>
                                                <th v-if="multiple" width="20"></th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Tags</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="user in pagination.data" :key="user.id" class="clickable-row" v-on:click="multiple ? toggleSelected(user) : userSelected(user)">
                                                <td v-if="multiple">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" :checked="selectedUsers.includes(user.id)"/>
                                                    </div>
                                                </td>
                                                <td>
                                                    <a href="javascript:void(0)">{{ user.full_name }}</a>
                                                </td>
                                                <td>{{ user.email }}</td>
                                                <td>
                                                    <p v-for="tag in user.tags" :key="tag.id">{{tag.tag_number}}</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="3">
                                                    <div class="is-text-centered">
                                                        <full-pagination
                                                            v-bind:pagination="pagination"
                                                            v-bind:content="pagination.data"
                                                            v-bind:offset="10"
                                                            @paginate="getPages">
                                                        </full-pagination>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                    <div v-if="showNotFoundMessage">
                                        {{notFoundMessage}}
                                    </div>
                                </template>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </portal>

    </div>
</template>

<script>
import {EventBus} from '@/V3/EventBus.js';
import {Modal} from 'bootstrap';
import Users from "../../Services/Users";
import FullPagination from "../UI/FullPagination.vue";
import Utils from "../../Services/Utils";

export default {
        name: "UserSearchComponent",
        props: {
            activeBooking: {
                type: Boolean,
                default: false,
                required: false
            },
            activeCheckin: {
                type: Boolean,
                default: false,
                required: false
            },
            field: {
                type: Array,
                required: true
            },
            role: {
                type: Array,
                required: true
            },
            centre_id: {
                type: Number,
            },
            companyId: {
                type: Number,
                required: false
            },
            triggerText: {
                type: String,
                default: 'Search Users',
            },
            triggerClass: {
                type: String,
                default: 'btn btn-primary'
            },
            asMailInput: {
                type: Boolean,
                default: false,
            },
            defaultQuery: {
                type: String,
                default: ""
            },
            defaultUserId: {
                type: Number,
                default: null,
            },
            defaultUsers: {
                type: Array,
                default: () => [],
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            notFoundMessage: {
                type: String,
                default: ''
            }
        },
        components: {
            FullPagination,
        },
        data: function() {
            return {
                query: this.defaultQuery,
                pagination: {
                    data: []
                },
                loading: false,
                selectedUser: {
                    email: false
                },
                selectedUsers: [],
                showNotFoundMessage: false
            }
        },
        computed: {
            getSearchByFieldObject() {
                return {
                    field: this.field.join(),
                    role: this.role.join(),
                    query: this.query,
                    centre_id: this.centre_id,
                    company_id: this.companyId,
                    active_booking: this.activeBooking,
                    active_checkin: this.activeCheckin,
                }
            },
        },
        mounted() {
            this.initDefaultUser();
            this.initDefaultUsers();
            EventBus.on('all-forms-cancelled', this.clearForm);
            EventBus.on('user-unselected', this.userUnSelected);
        },
        watch: {
            query: {
                immediate: true,
                handler() {
                    this.showNotFoundMessage = false
                    if (Utils.validateEmail(this.query)) {
                        EventBus.emit('valid-email-address-entered', this.query);
                    }
                }
            }
        },
        methods: {

            handleEmailBlur: function() {
                this.searchByInput();
                this.loading = false;
            },

            initDefaultUser: function() {
                if (!this.defaultUserId) {
                    return;
                }

                this.loading = true;
                Users.getUserById(this.defaultUserId).then(res => {
                    EventBus.emit('user-selected', res.user);
                    this.selectedUser = res.user;
                    this.loading = false;
                });
            },

            initDefaultUsers: function() {
                if (this.defaultUsers.length <= 0) {
                    return;
                }

                this.loading = true;
                Users.getUsersByIds(this.defaultUsers).then(res => {
                    res.users.forEach(user => EventBus.emit('user-selected', user));
                    this.loading = false;
                });
            },

            search: function() {
                this.showNotFoundMessage = false;
                this.loading = true;
                Users.searchByField(this.getSearchByFieldObject).then( res => {
                    this.pagination = res;
                    this.loading = false;
                    this.showNotFoundMessage = this.query && !this.pagination.data.length
                });

            },

            searchByInput: function () {
                this.showNotFoundMessage = false;
                this.loading = true;
                Users.searchByField(this.getSearchByFieldObject).then( res => {
                    if (res.data && res.data.length === 1) {
                        if (!this.multiple) {
                            this.selectedUser = res.data[0];
                        }

                        this.userSelected(res.data[0]);
                    } else if(res.data && res.data.length === 0) {
                        this.showNotFoundMessage = true;
                    } else {
                        const modalEl = document.getElementById('userSearchModal');
                        const modal = Modal.getOrCreateInstance(modalEl);
                        modal.show();
                        this.pagination = res;
                        this.showNotFoundMessage = this.query && !this.pagination.data.length
                    }
                    this.loading = false;
                });
            },

            getPages: function(page) {
                this.pagination.current_page = page;
                let url = this.pagination.path + "?page=" + page;
                let paginated = Users.searchByField(this.getSearchByFieldObject, url).then( res => {
                    this.pagination = res;
                });
                this.$emit('paginated', paginated);
            },

            userSelected: function(user) {
                if (!this.multiple) {
                    EventBus.emit('user-selected', user);
                    this.selectedUser = user;
                    this.query = "";
                    const modalEl = document.getElementById('userSearchModal');
                    const modal = Modal.getOrCreateInstance(modalEl);
                    modal.hide();

                    return;
                }

                if (!this.selectedUsers.includes(user.id)) {
                    EventBus.emit('user-selected', user);
                    this.selectedUsers.push(user.id);
                }
            },

            toggleSelected: function (user) {
                if (this.selectedUsers.includes(user.id)) {
                    EventBus.emit('user-unselected', user);
                } else {
                    EventBus.emit('user-selected', user);
                    this.selectedUsers.push(user.id);
                }
            },

            userUnSelected: function(user) {
                this.selectedUsers = this.selectedUsers.filter(id => id !== user.id);
            },

            clearForm: function () {
                this.query = '';
                this.selectedUser = {
                    email: false
                };
            }
        }
    }
</script>

<style scoped>
    .search-input {
        position: absolute;
        top: 0;
        right: 0;
        outline: none;
        height: 30px;
        margin: 0;
        z-index: 10;
        width: 300px;
        font-family: inherit;
        border-radius: 22px;
        color: #babfbf;
        box-shadow: none;
        border: 1px solid #979ca2;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.6;
    }

    .search-input__button {
        background: #fff;
        filter: alpha(opacity=0);
        opacity: 0;
        color: transparent;
        border: none;
        outline: none;
        width: 25px;
    }

    .search-form_wrapper {
        width: 300px;
        margin-left: 15px;
    }

    .modal-header {
        display: flex;
    }

    .table-borderless td, .table-borderless tr {
        border: none;
    }

    .is-text-centered {
        text-align: center;
    }

    .user-search-title {
        margin: 0;
    }

    .right-border-none {
        border-right: 0;
    }

    .user-search-button{
        padding-left: 4px;
        padding-right: 20px;
    }
</style>
